import React from 'react'
import PropTypes from 'prop-types'

const NewTabList = ({ tabData }) => {
  return (
    <div className="mb-4 p-4 shadow-sm rounded-4 bg-white">
      <div
        className="nav nav-pills gap-3"
        id="v-pills-tab"
        role="tablist"
        aria-orientation={tabData?.ariaOrientation}>
        {tabData?.tabListData?.map((tab, index) => {
          return (
            <button
              key={index}
              className={`align-items-center d-flex justify-content-between nav-link fw-semibold ${index === 0 && 'active'}`}
              id={`v-${tab?.id}-tab`}
              data-bs-toggle="pill"
              data-bs-target={`#v-${tab?.id}`}
              type="button"
              role="tab"
              aria-controls={`v-${tab?.id}`}
              aria-selected={index === 0 ? "true" : "false"}>
              <span>{tab?.tabName}</span>
            </button>
          )
        })}
        {/* <button
          className="align-items-center d-flex justify-content-between nav-link fw-semibold"
          id="v-PersonalDetails-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-PersonalDetails"
          type="button"
          role="tab"
          aria-controls="v-PersonalDetails"
          aria-selected="false">
          <span>
            Personal details
          </span>
        </button> */}
      </div>
    </div>
  )
}

export default NewTabList

NewTabList.propTypes = {
  tabData: PropTypes.any,
}
